import { render } from "./SetLowHcpiDialog.vue?vue&type=template&id=0c4bba82"
import script from "./SetLowHcpiDialog.vue?vue&type=script&lang=js"
export * from "./SetLowHcpiDialog.vue?vue&type=script&lang=js"
script.render = render

export default script